<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('Announcements') }}
    </h1>

    
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import axiosInstance from '@/services'

const isLoading = ref(false)
const announcements = ref()

onMounted(async () => {
  await fetchAnnouncements()
  isLoading.value = true
})

async function fetchAnnouncements() {
  const response = axiosInstance.get('/api/announcement/getActive', {
    params: {
      announcementType: 2
    }
  })

  announcements.value = response.announcements
}
</script>

<style lang="scss" scoped></style>
